import { headerConstants, configConstants } from '../_constants';
import { headerService } from '../_services';
import { utilityHelper } from '../_helpers';
/**
 * headerActions
 *
 * @package                onboard
 * @subpackage             headerActions
 * @category               Actions
 * @DateOfCreation         10 May 2019
 * @ShortDescription       This is responsible to handle all action related to header
 */

export const headerActions = {
    logout
};

/**
* @DateOfCreation        22 May 2019
* @ShortDescription      This function is responsible for logout
* @return                JSON object
*/
function logout() {
    return dispatch => {
       headerService.logout()
            .then(
                response => { 
                    var data = response.data;
                    if(response.status === configConstants.SUCCESS_CODE){
                        utilityHelper.doLogout();  
                    }else{
                        var errorMsg = utilityHelper.getFirstErrorMessage(data.error);
                        dispatch(failure(errorMsg));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };
// Actions defination that will perform according dispatch call and send data to reducer
    function success(success) { return  { type   : headerConstants.LOGOUT_SUCCESS, success } }
    function failure(error) { return    { type   : headerConstants.LOGOUT_FAILURE, error } }
}
